// MOD-CUSTOM: Add Judge.me modifications code work whenever Judge.me widget is detected.
document.querySelector('.jdgm-write-rev-link').addEventListener('click', e => {
  document.querySelectorAll('#judgeme_product_reviews > div > div.jdgm-rev-widg__header > div.jdgm-form-wrapper > form > div:nth-child(2) > span > a:nth-child(5)')[0].click();
  document.querySelectorAll('[name="reviewer_name_format"]')[0].options.selectedIndex = 1;
  let jdgmNameParent = document.querySelector('.jdgm-form__reviewer-name-format-container');
  for (let i = 0; i < jdgmNameParent.childNodes.length; i++) {
    if (jdgmNameParent.childNodes[i].nodeType === 3) {
      jdgmNameParent.removeChild(jdgmNameParent.childNodes[i]);
    }
  }
  document.querySelector('.jdgm-form__fieldset:has(.jdgm-form__reviewer-name-format-container) > label').innerText = 'Name,'
});
